import { render, staticRenderFns } from "./production-calendar copy.vue?vue&type=template&id=5bcd2faa"
import script from "./production-calendar copy.vue?vue&type=script&lang=js"
export * from "./production-calendar copy.vue?vue&type=script&lang=js"
import style0 from "./production-calendar copy.vue?vue&type=style&index=0&id=5bcd2faa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports